/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/
import React from 'react';

import { ProductHeaderInput } from './../coc-c-invoice-details.view';
import { IInvoiceDetailsViewProps } from '@msdyn365-commerce-modules/invoice-details/src/modules/invoice-details/./invoice-details';

const InvoiceDetailsPaymentDetails: React.FC<{
    className: string;
    id: string;
    data: ProductHeaderInput;
    properties: IInvoiceDetailsViewProps;
}> = (props): JSX.Element | null => {
    const lineClassName = `${props.className}__line`;

    return (
        <div className={props.className}>
            <div className='msc-invoice-details__payment-details__line-subtotal msc-invoice-details__payment-details__line'>
                <div className={`${lineClassName}__label`}>Total product Value</div>
                <div className={`${lineClassName}__value`}>
                    ${`${props.data.totalProductValue}` ? props.data.totalProductValue?.toFixed(2) : '-'}
                </div>
            </div>
            {/* <div className='msc-invoice-details__payment-details__line-shipping msc-invoice-details__payment-details__line'>
                <div className={`${lineClassName}__label`}>Shipping</div>
                <div className={`${lineClassName}__value`}>{props.data.shipping ? props.data.shipping?.toFixed(2) : '-'}</div>
            </div> */}
            <div className='msc-invoice-details__payment-details__line-total-tax msc-invoice-details__payment-details__line'>
                <div className={`${lineClassName}__label`}>Total Taxes (GST)</div>
                <div className={`${lineClassName}__value`}>{props.data.totalTaxes ? `$${props.data.totalTaxes?.toFixed(2)}` : '-'}</div>
            </div>
            <div className='msc-invoice-details__payment-details__line-total-amount msc-invoice-details__payment-details__line'>
                <div className={`${lineClassName}__label`}>Invoice total:</div>
                <div className={`${lineClassName}__value`}>${props.data.invoiceTotal ? props.data.invoiceTotal?.toFixed(2) : '-'}</div>
            </div>
        </div>
    );
};

export default InvoiceDetailsPaymentDetails;
